import React from 'react';

import * as Styled from './StyledRelationship';

export function RelationshipCard(props) {
    const data = props.data || props.relationship || undefined;
    const startup = data.startup.data;

    // No year found?
    if (!data.year) data.year = 'N/D';

    const bold = data.company.name;
    const text = `${data.year} - ${data.programName}`;

    const propsCard = {
        as: data.onClick ? 'button' : undefined,
        onClick: data.onClick,
    };
    return (
        <Styled.RelationshipCard {...propsCard}>
            <Styled.CardImage img={encodeURI(startup.logoUrl)} />
            <Styled.CardInfos>
                <span className="name">{startup.name}</span>
                <span className="bold">{bold}</span>
                <span className="text">{text}</span>
            </Styled.CardInfos>
        </Styled.RelationshipCard>
    );
}
export default RelationshipCard;
